import { render, staticRenderFns } from "./Leftovers.vue?vue&type=template&id=18a20ffe&scoped=true&"
import script from "./Leftovers.vue?vue&type=script&lang=js&"
export * from "./Leftovers.vue?vue&type=script&lang=js&"
import style0 from "./Leftovers.vue?vue&type=style&index=0&id=18a20ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a20ffe",
  null
  
)

component.options.__file = "Leftovers.vue"
export default component.exports